module.exports = __webpack_public_path__ + "media/packs/images/partners/partner1-a086a2050f30c9fac83ab28f3b8582c7.jpg";